import getPartnerAsset from 'packages/smart-home-support/assets';
import { DynamicAssetsKeys, NavItem } from 'packages/smart-home-support/assets/models';
import { LinkId } from 'packages/smart-home-support/constants';

const termsLinkTo = getPartnerAsset(DynamicAssetsKeys.finePrintLinkTo);
const termsLinkLabel = getPartnerAsset(DynamicAssetsKeys.finePrintLinkLabel);

export const legal: NavItem[] = [
  {
    id: LinkId.FooterMenuTermsConditions,
    to: termsLinkTo,
    label: termsLinkLabel,
  },
  {
    id: LinkId.FooterMenuTermsOfUse,
    to: 'https://www.asurion.com/terms-conditions/',
    label: 'Terms of Use',
  },
  {
    id: LinkId.FooterMenuPrivacyPolicy,
    to: 'https://www.asurion.com/privacy-policy/',
    label: 'Privacy Policy',
  },
];



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/data/navItems.ts